import { render, staticRenderFns } from "./OrganisationCategoryAdd.vue?vue&type=template&id=0b5ab170&scoped=true&"
import script from "./OrganisationCategoryAdd.vue?vue&type=script&lang=js&"
export * from "./OrganisationCategoryAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5ab170",
  null
  
)

export default component.exports